/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  
MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var observer = new MutationObserver(function(mutations, observer) {
    // fired when a mutation occurs
    console.log('mutations', mutations, observer);
    // ...
    observer.disconnect()
     setTimeout(function(){
        if(document.querySelector('.shopify-payment-button__button--unbranded')){
            document.querySelector('.shopify-payment-button__button--unbranded').innerText = 'Purchase now';
        }
     })
});

var handldVatPrice = function(shipping_tax_box, variantPrice=null){
    
    var EU_Countries = "LU,MT,CY,DE,RO,AT,BG,EE,FR,SK,BE,CZ,ES,LT,LV,NL,IT,SI,IE,PL,PT,EL,FI,DK,HR,SE,HU".split(',');
    var EU_VAT= "17,18,19,19,19,20,20,20,20,20,21,21,21,21,21,21,22,22,23,23,23,24,24,25,25,25,27".split(',');

    var priceElement = shipping_tax_box.querySelector('.vat_price');

    //handle ETH Price
    let updatePrice = function(){
        if(document.querySelector('.Price__Etherium')){
            let price = priceElement.dataset.price ; 
            if( variantPrice !=null )
                price = variantPrice;
            let ETHPrice = (price/window.ETH_rate/100);

            document.querySelector('.Price__Etherium').querySelector('.Price').innerText = ETHPrice.toFixed(3).toString().replace('.',',') + ' ETH';
            if(!document.querySelector('.Price__Etherium').classList.contains('active')) {
                document.querySelector('.Price__Etherium').classList.add('active');
            }   
        }
    } 
    if(window.ETH_rate){
        updatePrice();
    }else{
        var cacheValid= false;
        if(window.theme.cryptocompare && window.theme.cryptocompare.date != null ){
            var dataDate = new Date(window.theme.cryptocompare.date);
            var nowDate = new Date();
            if(nowDate.getDate() == dataDate.getDate()){
                let timeDiff = nowDate.getTime() - dataDate.getTime();
                if( timeDiff/(1000*60*60) < 1){
                    cacheValid = true;
                }
            }
        }
        console.log('cacheValid ', cacheValid)
        if(cacheValid){
            window.ETH_rate = window.theme.cryptocompare.data.EUR;
            updatePrice();
        }else{
            fetch('https://private-services.herokuapp.com/konig/cryptocompare')
            .then(res => res.json())
            .then((response)=>{
                console.log('TH response', response.EUR);
                window.ETH_rate = response.EUR;
                updatePrice();
            }).catch((e)=>{ console.log("error ", e)});    
        }
    }


    if(shipping_tax_box.className.indexOf('novat') > -1 ){
        return;
    }
    if(EU_Countries.indexOf(window.theme.userCountryCode) > -1 ){ 
        shipping_tax_box.classList.add('UE');
        var vat = EU_VAT[EU_Countries.indexOf(this.window.theme.userCountryCode)];

        if(shipping_tax_box.dataset.vatForce && window.theme.userCountryCode == 'DE'){
            vat = shipping_tax_box.dataset.vatForce;
        }
        shipping_tax_box.querySelector('.vat_percentage').innerText = vat + '%';
        // if(vat != '19'){
                let newPrice = priceElement.dataset.price * (1 + parseFloat(vat)/100 );
                if( variantPrice !=null ){
                    newPrice=variantPrice * (1 + parseFloat(vat)/100 );
                }
            priceElement.innerText = __WEBPACK_IMPORTED_MODULE_3__helper_Currency__["default"].formatMoney(newPrice, window.theme.moneyFormat);
        // }
    }else{
        shipping_tax_box.classList.add('out-UE');
    }

}

// if(window.location.href.indexOf('/cart') > -1 ){
    // document.addEventListener('theme:loading:end', function(){
        var cart_form = document.querySelector('form.Cart'),
            cart_btn = document.querySelector('form.Cart button[type="submit"]'),
            terms_input = document.querySelector('input[name="terms_policy"]'),

            nft_terms_input = document.querySelector('input[name="terms_policy_nft"]'),
            cart_error = document.querySelector('.cart_terms_error');
        // setTimeout(function(){
        // console.log(' yesssssssss ')
        // console.log('cart_btn ', cart_btn)
        function handleChecked(){
            if(nft_terms_input){
                if(terms_input.checked && nft_terms_input.checked ){ 
                    cart_error.style.display='none';
                }
            }else if(terms_input.checked){ 
                cart_error.style.display='none';
            }
        }
        if(terms_input){
            terms_input.addEventListener('change', function(e){ 
                handleChecked();
            });
        }

        if(nft_terms_input){
            nft_terms_input.addEventListener('change', function(e){ 
                handleChecked();
            });  
        }
        document.addEventListener('submit', function(e){
            console.log('submit')
            cart_error = document.querySelector('.cart_terms_error');
            terms_input = document.querySelector('input[name="terms_policy"]');
            nft_terms_input = document.querySelector('input[name="terms_policy_nft"]');

            if(e.target.className.indexOf('Cart') == - 1 )
                return;
            console.log('cart_form ', cart_form);
            if(nft_terms_input){
                if(terms_input.checked && nft_terms_input.checked){ 
                    cart_error.style.display='none';  
                }else{
                    e.preventDefault();
                    cart_error.style.display='block';
                }            
            }
            else if(terms_input.checked){ 
                cart_error.style.display='none';
            }else{
                e.preventDefault();
                cart_error.style.display='block';
            }
        });
        // }, 1500)
    // })

//  }
 
 function handleTermsCheck(){
    setTimeout(function(){
    var cart_form = document.querySelector('form.Cart'),
        cart_btn = document.querySelector('form.Cart button[type="submit"]'),
        terms_input = document.querySelector('input[name="terms_policy"]'),

        nft_terms_input = document.querySelector('input[name="terms_policy_nft"]'),
        cart_error = document.querySelector('.cart_terms_error');

    console.log('cart_btn ', cart_btn)
    function handleChecked(){ 
        if(nft_terms_input){
            if(terms_input.checked && nft_terms_input.checked ){ 
                cart_error.style.display='none';
            }
        }else if(terms_input.checked){ 
            cart_error.style.display='none';
        }
    }
    if(terms_input)
    {
        terms_input.addEventListener('change', function(e){ 
            handleChecked();
        });
    } 
    if(nft_terms_input){
        nft_terms_input.addEventListener('change', function(e){ 
            handleChecked();
        });  
    }
    cart_form.addEventListener('submit', function(e){
        console.log('cart_form ', cart_form);
        if(nft_terms_input){
            if(terms_input.checked && nft_terms_input.checked){ 
                cart_error.style.display='none';  
            }else{
                e.preventDefault();
                cart_error.style.display='block'; 
            }            
        }
        else if(terms_input.checked){ 
            cart_error.style.display='none';
        }else{
            e.preventDefault();
            cart_error.style.display='block';
        }
    });
    }, 1000)
}
// if(window.location.href.indexOf('/cart') > -1 ){
window.addEventListener('cart:refresh', function(){
    console.log('handleTermsCheck refresh')
    handleTermsCheck();
});
document.addEventListener('DOMContentLoaded', function(){
    handleTermsCheck();
})

 window.addEventListener('load', function(){

     if(window.location.href.indexOf('/products') > -1 ){
        //handled disabled links 
        var disabled_links = document.querySelectorAll('a[disabled], .dubm-clickable');
        for(var i=0; i < disabled_links.length; i++){
            disabled_links[i].addEventListener('click', function(e){
                e.preventDefault();
                if(e.target.className.indexOf('BIS') > -1)
                    return;
                document.querySelector('.open-login-modal').click();
            });
        }
        //  setTimeout(function(){
        //     if(document.querySelector('.shopify-payment-button__button--unbranded')){
        //         document.querySelector('.shopify-payment-button__button--unbranded').innerText = 'Purchase now';
        //     }
        //  })
        //  var payment_wrapper = document.querySelector('div[data-shopify="payment-button"]');
        //  if(payment_wrapper){
        //     observer.observe(payment_wrapper, {
        //         characterDataOldValue: true, 
        //         subtree: true, 
        //         childList: true, 
        //         characterData: true 
        //     });
        //  }


         var info_tooltip_toggle_wrapper = document.querySelectorAll('.tooltip_taxes_shipping__wrapper');
        //  var info_tooltip_toggles = document.querySelectorAll('.tooltip_taxes_shipping');
         for( var i =0 ; i < info_tooltip_toggle_wrapper.length; i++){
            (function(){
            info_tooltip_toggle = info_tooltip_toggle_wrapper[i].querySelector('.tooltip_taxes_shipping');
            if(info_tooltip_toggle){
                var tooltip_info = info_tooltip_toggle_wrapper[i].querySelector('.taxes_info');
                info_tooltip_toggle.addEventListener('click', function(e){
                     if(tooltip_info.classList.contains('show')){
                         tooltip_info.classList.remove('show');
                     }else{
                        tooltip_info.classList.add('show');
                     }
                 });
             
                var tooltip_popup = info_tooltip_toggle_wrapper[i].querySelector('.taxes_info span');
                tooltip_popup.addEventListener('click', function(){
                    tooltip_info.classList.remove('show');
                });
            }
            })();

         }


        var shipping_tax_box = document.querySelector('.taxes_shipping');


        handldVatPrice(shipping_tax_box);

        document.addEventListener('variant:changed', function(e){
            handldVatPrice(shipping_tax_box, e.detail.variant.price);
        });

    }


    //collectio pages
    else if(window.location.href.indexOf('/collections') > -1 || window.location.href.indexOf('/my-wishlist') > -1 ){
        handleShippingTaxes();
    }

 })

function handleShippingTaxes(){
    var shipping_tax_boxs = document.querySelectorAll('.taxes_shipping');
    shipping_tax_boxs.forEach(function(e){
        (function(e){
            handldVatPrice(e);     
        })(e);
    })
}